import { Modal, Empty } from "antd";
import { Flex } from "@chakra-ui/react";
import OutlineButton from "ui/components/Button/OutlineButton";
import Historico from "./components/Historico";
import useHistoricoUnidade from "core/features/unidades/useHistoricoUnidade";
import { useLoading } from "ui/components/GlobalLoading/index";

interface ModalHistoricoProps {
  isOpenModal: boolean;
  onClose: () => any;
  id: string | undefined;
}

export default function ModalHistorico({
  id,
  isOpenModal,
  onClose,
}: ModalHistoricoProps) {
  const { data, isLoading, isFetching } = useHistoricoUnidade(id);

  useLoading(isLoading || isFetching);

  return (
    <Modal
      visible={isOpenModal}
      onCancel={onClose}
      centered
      footer={
        <Flex flex={1} justifyContent="end">
          <OutlineButton onClick={onClose}>Fechar</OutlineButton>
        </Flex>
      }
    >
      <Historico logs={data ?? []} />
      {!data?.length && !isLoading && !isFetching ? (
        <Empty description="Sem dados de histórico para essa unidade" />
      ) : null}
    </Modal>
  );
}
